import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ 
  message = "Loading Cringe Quest...", 
  imageUrl = "https://nzbukggxgocbupparhnl.supabase.co/storage/v1/object/public/public-images//cringe_loading_countdown.gif",
  imageAlt = "Loading...",
  imageWidth = "400px",
  imageHeight = "400px",
  overlay = false,
}) => {
  return (
    <div
      className={`app-background-wrapper cq-loading-shell${overlay ? ' cq-loading-shell--overlay' : ''}`}
      style={{ '--cq-loading-bg': `url(${process.env.PUBLIC_URL}/images/bg_artdeco_pattern.png)` }}
    >
      <div className="app-background cq-loading-shell__background">
        <div className="loading-screen-container">
          <div className="loading-screen-panel">
            <div
              className="loading-image-frame"
              style={{
                width: imageWidth,
                height: imageHeight,
              }}
            >
              <img
                src={imageUrl}
                alt={imageAlt}
                className="loading-image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
              <span className="loading-image-label" aria-hidden="true">
                LOADING
              </span>
            </div>
            <p className="loading-message">
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
